var v1="<div>  <hr class=\"horizontalLine\"/> </div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/lbaSpacer/lbaSpacer.html", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbaSpacer/lbaSpacer.html
// module id = 431
// module chunks = 0